import React, { useState } from 'react';

import {
    KYC_MODAL_STEP_ERROR,
    KYC_MODAL_STEP_INIT,
    KYC_MODAL_STEP_IN_PROGRESS
} from '../../../services/kyc/constants';

import KycStep1 from './KycStep1';
import KycStep2 from './KycStep2';
import KycStepError from './KycStepError';

import { KycModalContainer } from './KycModalStyle';

const KycModal = ({ useCase }) => {
    const [step, setStep] = useState(KYC_MODAL_STEP_INIT);
    const [errorType, setErrorType] = useState(null);

    return (
        <KycModalContainer>
            {step === KYC_MODAL_STEP_INIT && (
                <KycStep1 setStep={setStep} setErrorType={setErrorType} useCase={useCase} />
            )}
            {step === KYC_MODAL_STEP_IN_PROGRESS && (
                <KycStep2 setStep={setStep} setErrorType={setErrorType} useCase={useCase} />
            )}
            {step === KYC_MODAL_STEP_ERROR && <KycStepError errorType={errorType} />}
        </KycModalContainer>
    );
};

export default KycModal;



// WEBPACK FOOTER //
// ./src/components/fraud/kyc/KycModal.js